<template>
    <div v-bind="$attrs" v-on="$listeners">
        <div v-if="hasExcluding">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        v-bind="attrs"
                        v-on="Object.assign({}, on, listenersProxy)"
                        :class="excludingClasses"
                    >
                        <stroke :strike="strike">
                            {{ price(excludingVat, currency) }}
                        </stroke>
                        <template v-if="showUnit"> / {{ unitDisplay }} </template>
                    </span>
                </template>
                <div class="price-tooltip-content">
                    <div>{{ $translate("excludingVat") }}</div>
                    <div v-if="tooltip">{{ tooltip }}</div>
                </div>
            </v-tooltip>
        </div>
        <div
            v-if="hasIncluding"
            class="mt-1"
            :class="includingWrapperClasses"
        >
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        v-bind="attrs"
                        v-on="Object.assign({}, on, listenersProxy)"
                        :class="includingClasses"
                    >
                        <stroke :strike="strike">
                            {{ price(includingVat, currency) }}
                        </stroke>
                        <template v-if="showUnit"> / {{ unitDisplay }} </template>
                    </span>
                </template>
                <div class="price-tooltip-content">
                    <div>
                        <span>{{ $translate("includingVat") }}</span>
                        <template v-if="vatRate">
                            <span>
                                ({{ $translate("vat_rate") }}
                                {{ percent(vatRate) }})
                            </span>
                        </template>
                    </div>
                    <div v-if="tooltip">{{ tooltip }}</div>
                </div>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import GlobalMixins from "@/mixins/global";
import { Decimal } from "decimal.js";

export default {
    mixins: [GlobalMixins],
    inheritAttrs: false,
    props: {
        excludingVat: {
            required: false,
            type: [Number, String, Decimal],
        },
        includingVat: {
            required: false,
            type: [Number, String, Decimal],
        },
        vatRate: {
            required: false,
            type: [Number, String, Decimal],
        },
        highlight: {
            required: false,
            type: String,
            default: "excludingVat",
        },
        strike: {
            required: false,
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            default: null,
        },
        unit: {
            required: false,
            type: String,
            default: "piece",
        },
        currency: {
            required: false,
            type: String,
            default: "EUR",
        },
    },
    computed: {
        hasExcluding() {
            return (
                this.excludingVat !== null && typeof this.excludingVat !== "undefined"
            );
        },
        hasIncluding() {
            return (
                this.includingVat !== null && typeof this.includingVat !== "undefined"
            );
        },
        excludingClasses() {
            return {
                "grey--text": this.highlight == "includingVat",
                "font-weight-bold": this.highlight != "includingVat",
            };
        },
        includingWrapperClasses() {
            return {
                "grey--text": this.highlight != "includingVat",
                "font-weight-bold": this.highlight == "includingVat",
            };
        },
        includingClasses() {
            return {
                "grey--text": this.highlight != "includingVat",
                "font-weight-bold": this.highlight == "includingVat",
            };
        },
        listenersProxy() {
            return this.$listeners || {};
        },
        showUnit() {
            return this.unit && this.unit !== "piece";
        },
        unitDisplay() {
            if (this.unit === "weight") {
                return "kg";
            } else if (this.unit === "volume") {
                return "L";
            }
            return "u";
        },
    },
    i18n: {
        messages: {
            en: {
                excludingVat: "Excluding VAT",
                includingVat: "Including VAT",
                vat_rate: "VAT",
            },
            fr: {
                excludingVat: "HT",
                includingVat: "TTC",
                vat_rate: "TVA",
            },
        },
    },
};
</script>
